export const ABSENCE = 'ABSENCE';
export const RUNAWAY = 'RUNAWAY';

export const PENALTY_TYPES = [ABSENCE, RUNAWAY] as const;

export type PenaltyType = (typeof PENALTY_TYPES)[number];
